jQuery.noConflict()(function($) {
    $('.studio-a .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.studio-a .stu-next-btn',
        prevSelector:'.studio-a .stu-prev-btn',
        pagerCustom: '.studio-a #bx-pager',
    });
    $('.studio-b .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.studio-b .stu-next-btn',
        prevSelector:'.studio-b .stu-prev-btn',
        pagerCustom: '.studio-b #bx-pager',
    });
    $('.office .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.office .stu-next-btn',
        prevSelector:'.office .stu-prev-btn',
        pagerCustom: '.office #bx-pager',
    });
    $('.shop-a .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.shop-a .stu-next-btn',
        prevSelector:'.shop-a .stu-prev-btn',
        pagerCustom: '.shop-a #bx-pager',
    });
    $('.shop-b .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.shop-b .stu-next-btn',
        prevSelector:'.shop-b .stu-prev-btn',
        pagerCustom: '.shop-b #bx-pager',
    });
    $('.ma-recording .slideStudio').bxSlider({
        mode:'fade',
        speed:1200,
        pause: 4500,
        slideMargin:0,
        pager:true,
        controls:true,
        auto: false,
        minSlides: 3,
        nextSelector:'.ma-recording .stu-next-btn',
        prevSelector:'.ma-recording .stu-prev-btn',
        pagerCustom: '.ma-recording #bx-pager',
    });
});




